export const DEFAULT_LOCALE = 'en-GB'
export const CURRENCY = 'GBP'
export const CURRENCY_SYMBOL = '£'

export const SUPPORT_EMAIL = 'support@taxfix.com'
export const SUPPORT_PHONE_NUMBER = '020 3983 5003'
export const TWITTER_HANDLE = 'Taxfix'

export const PRICE_SUBSCRIPTION = 26
export const PRICE_SUBSCRIPTION_COMPANY = 39
export const PRICE_BUNDLE = 249
export const PRICE_REGULAR = 169
export const PRICE_PAY_LATER = 279
export const PRICE_TAX_CONSULTATION = 139
export const PRICE_TAX_REGISTRATION = 25
export const PRICE_TAX_RELIEF_CLAIM_EIS = 25
export const PRICE_CURRENCY = CURRENCY
export const AMOUNT_SAVED_WITH_BUNDLE = PRICE_REGULAR + PRICE_TAX_CONSULTATION - PRICE_BUNDLE

export const API_NAME_HMRC = 'Hmrc'

export const USER_TYPE_ACCOUNTANT = 'Accountant'
export const USER_TYPE_CUSTOMER = 'Customer'
export const USER_TYPE_SYSTEM = 'System'

export const MESSAGE_TEXT_TYPE_SMS = 'Sms'

export const ACCOUNTANT_PAUSED_STATUS_TYPE_UNAVAILABLE = 'Unavailable'

export const TRUSTBOX_DEFAULT_TEMPLATE_ID = '54ad5defc6454f065c28af8b'
export const TRUSTBOX_DEFAULT_BUSINESSUNIT_ID = '68c038c6e21d291852a4d4cb'

// Profile

export const TITLES = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Rev', 'Other']
export const TITLE_OTHER = 'Other'

export const MARITAL_STATUS_SINGLE = 'Single'
export const MARITAL_STATUS_MARRIED = 'Married'
export const MARITAL_STATUS_WITH_PARTNER = 'WithPartner'

export const ADDRESS_TYPE_PREVIOUS = 'Previous'

export const ERROR_CODE_POSTCODE_LOOKUP_NOT_FOUND = 4040

// Issues

export const ISSUE_CATEGORY_REQUESTED_DOCUMENT = 'RequestedDocument'
export const ISSUE_TYPE_BANK_DETAILS_MISSING = 'BankDetailsMissing'

// Product types

export const PAYMENT_TYPE_TAX_CONSULTATION = 'TaxConsultation'
export const PAYMENT_TYPE_TAX_REGISTRATION = 'TaxRegistration'
export const PAYMENT_TYPE_PRODUCT_BUNDLE = 'ProductBundle'
export const PAYMENT_TYPE_SELF_ASSESSMENT = 'SelfAssessment'
export const PAYMENT_TYPE_TAX_RELIEF_CLAIM = 'TaxReliefClaim'
export const PAYMENT_TYPE_COMPANY_RETURN = 'CompanyReturn'
export const PAYMENT_TYPE_ADDITIONAL_CHARGE = 'AdditionalCharge'
export const PAYMENT_TYPE_SUBSCRIPTION = 'Subscription'

export const USER_AGREEMENT_TYPE_SELF_ASSESSMENT = 'SelfAssessment'
export const USER_AGREEMENT_TYPE_TAX_CONSULTATION = 'TaxConsultation'
export const USER_AGREEMENT_TYPE_TAX_REGISTRATION = 'TaxRegistration'

export const PRODUCT_TYPE_TAX_CONSULTATION = 'TaxConsultation'
export const PRODUCT_TYPE_SELF_ASSESSMENT = 'SelfAssessment'

// UI

export const INTERCOM_PADDING_BOTTOM = 96

export const paymentTypes = {
    [PAYMENT_TYPE_TAX_CONSULTATION]: PAYMENT_TYPE_TAX_CONSULTATION,
    [PAYMENT_TYPE_TAX_REGISTRATION]: PAYMENT_TYPE_TAX_REGISTRATION,
    [PAYMENT_TYPE_PRODUCT_BUNDLE]: PAYMENT_TYPE_PRODUCT_BUNDLE,
    [PAYMENT_TYPE_SELF_ASSESSMENT]: PAYMENT_TYPE_SELF_ASSESSMENT,
    [PAYMENT_TYPE_TAX_RELIEF_CLAIM]: PAYMENT_TYPE_TAX_RELIEF_CLAIM,
    [PAYMENT_TYPE_ADDITIONAL_CHARGE]: PAYMENT_TYPE_ADDITIONAL_CHARGE,
    [PAYMENT_TYPE_COMPANY_RETURN]: PAYMENT_TYPE_COMPANY_RETURN,
    [PAYMENT_TYPE_SUBSCRIPTION]: PAYMENT_TYPE_SUBSCRIPTION,
} as const

export const UserType = {
    Customer: 'Customer',
    Accountant: 'Accountant',
    System: 'System',
} as const
